import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import PaulussenLogo from "../assets/sponsors/paulussen_logo.svg"

const readmore: { [key: string]: string } = {
  nl: "Meer lezen",
  en: "Read more",
  de: "Mehr lesen",
}

export interface SponsorsProps {
  lang: string
}

function SponsorCard(
  props: React.PropsWithChildren<{
    lang: string
    href: string
    logo: React.ReactNode
    color: string
    textColor: string
  }>
) {
  return (
    <a href={`/${props.lang}/sponsors/${props.href}`}>
      <div
        className={`flex flex-col overflow-hidden pb-6 w-96 h-full rounded-2xl ${props.color} shadow-md max-w-md`}
      >
        {props.logo}
        <p
          className={`px-6 z-20 text-lg font-bold text-right ${props.textColor}`}
        >
          {readmore[props.lang]} &rarr;
        </p>
      </div>
    </a>
  )
}

export class Sponsors extends React.Component<SponsorsProps> {
  render() {
    return (
      <div className="flex lg:flex-row flex-col gap-4 items-stretch">
        <SponsorCard
          logo={
            <StaticImage
              src="../assets/bz_header_v2.jpg"
              alt="bz_header"
              placeholder="blurred"
            />
          }
          lang={this.props.lang}
          href="boels_zanders"
          color="bg-black"
          textColor="text-white"
        />
        <SponsorCard
          logo={<PaulussenLogo className="w-full px-12 py-6 h-full" />}
          lang={this.props.lang}
          href="paulussen"
          color="bg-gray-100"
          textColor="text-black"
        />
      </div>
    )
  }
}
